export default {"src":"/_next/static/media/loadinglight.969c7f4e.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};